import React, { useContext } from 'react';
import {
  Box,
  Typography,
} from '@material-ui/core';
import useStyles from './useStyles';
import { LabelInfo } from '../../../../components/LabelInfo';
import { LandingContext } from '../../../../context/landing';

export const AvisoPrivacidad = () => {
  const classes = useStyles();

  const { landingData } = useContext(LandingContext);

  const {
    privacyContent: {
      data,
    },
  } = landingData;

  const renderList = (title, items, listType = 'unordered', listStart = 1) => {
    const ListComponent = listType === 'ordered' ? 'ol' : 'ul';
    const listClassName = listType === 'ordered' ? classes.orderedList : classes.unorderedList;

    return (
      <ListComponent
        key={title}
        className={`${classes.list} ${listClassName}`}
        start={listType === 'ordered' ? listStart : undefined}
      >
        {items.map(({ type: itemType, bold: itemBold = false, text: itemText = '' }) => {
          switch (itemType) {
            case 'text':
            default:
              return (
                <li key={itemText} className={classes.listItem}>
                  <Typography className={`${classes.paragraph} ${itemBold ? classes.boldText : ''}`}>
                    {itemText}
                  </Typography>
                </li>
              );
          }
        })}
      </ListComponent>
    );
  };

  return (
    <>
      <LabelInfo label={data.title} />
      <Box variant="section" className={classes.container}>
        <Box variant="div" className={classes.innerContainer}>
          {/* <Box variant="div" className={classes.header}>
          <Typography variant="h2" className={classes.title}>
            {privacyContent.title}
          </Typography>
        </Box> */}

          {data.sections.map((section) => (
            <Box key={section.title} className={classes.section}>
              {
                section.title && (
                  <Typography variant="h5" className={classes.sectionTitle}>
                    {section.title}
                  </Typography>
                )
              }
              {section.content.map(({
                type,
                title = '',
                bold = false,
                text = '',
                items = [],
                listType = 'unordered',
                listStart = 1,
              }) => {
                switch (type) {
                  case 'paragraph':
                    return (
                      <Typography
                        key={text}
                        className={`${classes.paragraph} ${
                          bold ? classes.boldText : ''
                        }`}
                      >
                        {text}
                      </Typography>
                    );
                  case 'bold':
                    return (
                      <Typography
                        key={text}
                        className={`${classes.paragraph} ${classes.boldText}`}
                      >
                        {text}
                      </Typography>
                    );
                  case 'list':
                    return renderList(title, items, listType, listStart);
                  default:
                    return null;
                }
              })}
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );
};
